// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"123":"9039fce9","334":"772b565c","687":"ad1af88a","688":"36bd1b09","787":"cda612ba"}[chunkId] + ".chunk.js";
};